import { NgModule } from '@angular/core';
import { ClickStopPropagation } from './click-stop-propagation.directive';
import { NavAnimationDirective } from './nav-animation.directive';

@NgModule({
  declarations: [NavAnimationDirective, ClickStopPropagation],
  exports: [NavAnimationDirective, ClickStopPropagation],
})
export class DirectivesModule {}
